module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.a929ac1f.svg";